import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const TermAndCondition = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <section
        style={{ marginTop: "80px" }}
        className="py-5 d-flex items-center bg-blue-1-05"
      >
        <div className="container">
          <div className="row y-gap-10 items-center justify-between">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center font-inter text-14 fw-500 text-light-1">
                <div className="col-auto">
                  <a href="/" className="cursor-pointer">
                    Home
                  </a>
                </div>
                <div className="col-auto">
                  <div className="">{">"}</div>
                </div>
                <div className="col-auto">
                  <div className="text-primary">Terms and Conditions</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="our-terms">
        <div className="container">
          <div className="">
            <div className="col-12">
              <div className="">
                <div className="grids mb20">
                  <h3 className="py-15">Terms & Conditions</h3>
                  <p className="py-10 pt-15">
                    Effective date: <strong>August 22, 2022</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>1. </b>FITIZEN INDIA LLP (“<strong>Company</strong>” or “
                    <strong>We</strong>” or “<strong>Us</strong>” and their
                    connotations) operates a website called Fitizen (url:{" "}
                    <a href="https://www.fitizen.co.in">
                      https://www.fitizen.co.in
                    </a>
                    ) (“<strong>Platform</strong>”) which is engaged in
                    providing the service of connecting any event
                    organisers/vendors/pacers/ runners and end users who wish to
                    avail the services offered by the event
                    organisers/vendors/pacers/ runners.
                  </p>
                  <p className="py-10">
                    <b>2. </b>Our Platform is primarily for the event
                    organisers/vendors/pacers/ runners who are enlisted on our
                    Platform and the end users who want to avail the services
                    provided by the event organisers/vendors/pacers. The Users
                    below the age of 18 years shall be deemed to have obtained
                    parental consent to use the Platform. The event
                    organisers/vendors/pacers/ runners hereinafter are referred
                    to as You. The term “<strong>User(s)</strong>” for the
                    purposes of this Privacy Policy shall be read as the event
                    organisers/vendors/pacers/ runners and/or You.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>3. </b>The Platform gathers certain information with
                    prior consent from the Users. Any capitalized term used but
                    not defined in this Privacy Policy shall have the meaning
                    attributed to it in our Terms.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>4. </b>.Our User’s privacy is extremely important to us.
                    We recognize the privacy concerns of the Users and hence as
                    a commitment to provide safe and secure experience on our
                    Platform, we have formulated this privacy policy to help
                    Users make an informed decision.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>LEGAL BASIS:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>1. </b>This Privacy Policy (‘‘
                    <strong>Privacy Policy</strong>’’) is meant to help the
                    Users understand what information we collect, why we collect
                    it, what information we disclose and how the Users can
                    update, manage, export, and delete their information. It
                    shall be read with the terms and conditions available on
                    [insert the link to the terms and conditions] (“
                    <strong>Terms</strong>”) and in compliance with the
                    following:
                  </p>
                  <div className="col-lg-12 ml10">
                    <div className="mt0">
                      <ul className="order_list list-style-type-bullet list-inline-item">
                        <li className="py-5">
                          The Information Technology Act, 2000
                        </li>
                        <li className="py-5">
                          The Information Technology (Reasonable Security
                          Practices and Procedures and Personal Information)
                          Rules, 2011 (the “<strong>IT Rules</strong>”)
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="mb15 py-10 text-justify">
                    The Information Technology (Intermediaries Guidelines)
                    Rules, 2011
                  </p>
                  <p className="mb15 py-10 text-justify">
                    This Privacy Policy and the Terms shall be governed by and
                    construed in accordance with the Arbitration and
                    conciliation Act 1996, or such similar laws of India which
                    are not in conflict with each other. Such shall be subject
                    to the exclusive jurisdiction of the competent courts of
                    Mumbai, India.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>CONSENT:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>1. </b>The Users will be deemed to have read, understood
                    and agreed to the terms as provided in this Privacy Policy.
                    By granting their assent to this Privacy Policy, Users’
                    provide consent to such use, collection and disclosure of
                    Personal Information as prescribed in this Privacy Policy.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>2. </b>We reserve the right to update or change our
                    Privacy Policy at any time and the Users should check this
                    Privacy Policy periodically.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>3. </b>.Continued use of the Service after we post any
                    modifications to the Privacy Policy on this page will
                    constitute the Users acknowledgment of the modifications and
                    their consent to abide and be bound by the modified Privacy
                    Policy. Users have the right to opt out of the Platform and/
                    or Services at any moment. In addition, the Users can, by
                    sending an email to mailto:fitizenindia@gmail.com, inquire
                    whether the Company is in possession of their personal data,
                    and they may also require the Company to delete and destroy
                    all such information.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>4.</b>In the event the Services are used on behalf of any
                    other individual (such as a child/ parent etc.), or on
                    behalf of any entity, the Users represent that they are
                    authorised to accept this Privacy Policy and share such data
                    as required on behalf of such person or entity.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>INFORMATION COLLECTED:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>1. </b>All information collected by the Company is with
                    the Users’ consent. The Company is however free to use,
                    collect, and disclose information of the Users which is in
                    the public domain.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>2. </b>When Users use / register on the Platform, the
                    Users may provide the Company with certain information
                    voluntarily specific to the nature of the service being
                    availed on the Platform and/or certain information may be
                    collected by the Company. This information may include
                    sensitive personal information as defined under the IT rules
                    (“
                    <strong>Personal Information</strong>”).
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>3. </b>The Users hereby consent to the collection of such
                    information by the Company.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>4. </b>Information collected by the Company shall include
                    but not be limited to the following:
                    <div className="col-lg-12 ml10">
                      <div className="mt0">
                        <ul className="order_list list-style-type-bullet list-inline-item">
                          <li className="py-5"> Name;</li>
                          <li className="py-5">
                            Company details: (Name, address, GST & PAN)
                          </li>
                          <li className="py-5">
                            Contact Details (Permanent Address, Correspondence
                            Address, Email ID, Mobile No etc.);
                          </li>
                          <li className="py-5">Date of Birth, Nationality;</li>
                          <li className="py-5">
                            Age, Gender and other Demographics;
                          </li>
                          <li className="py-5">
                            financial information (like credit card, banking
                            details), if applicable.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>5. </b>We also collect certain information either when
                    the Users provide it using the Platform or Services and / or
                    automatically as you navigate through the Platform (which
                    may include usage details, IP address, device ID and type,
                    your browser type and language, the operating system used by
                    your device, access times, and information collected through
                    cookies, web beacons and other tracking technologies).
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>6. </b>We may also collect information associated with
                    any other account (such as your Facebook, Whatsapp, yahoo,
                    Google accounts) that you use to sign in to or in any other
                    manner connected with the Platform. This includes, without
                    limitation, any information that you have made public
                    through such an account, information that such account
                    service-provider shares with us or information that is
                    disclosed during the sign-up and sign-in processes.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>7. </b>If the Company has reasons to suspect that the
                    information provided by any User is misleading, inaccurate,
                    obsolete or incomplete, the Company reserves the right to
                    refuse provision of the Services to the User, at its sole
                    discretion.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>USE OF THE INFORMATION COLLECTED:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We collect Personal Information only necessary for the
                    following purposes:
                  </p>
                  <div className="col-lg-12 ml10 mb15">
                    <div className="mt0">
                      <ul className="order_list list-style-type-bullet list-inline-item">
                        <li className="py-5">
                          <b>1. </b>To create and maintain your account;
                        </li>
                        <li className="py-5">
                          <b>2. </b>To enable you to avail of our Services, and
                          ensure efficient customer care experience and develop
                          new features;
                        </li>
                        <li className="py-5">
                          <b>3. </b>To send surveys or marketing communications
                          to inform you of new products or services or other
                          information that may be of interest;
                        </li>
                        <li className="py-5">
                          <b>4. </b>To improve marketing and promotional
                          efforts, to analyze Platform usage, improve the
                          Platform’s content and Service offerings, and
                          customize the App’s content, layout, and Services;
                        </li>
                        <li className="py-5">
                          <b>5. </b>To dispatch transaction-related
                          communications such as welcome letters and billing
                          reminders;
                        </li>
                        <li className="py-5">
                          <b>6. </b>To notify the necessary information related
                          to the Platform and your account on the Platform from
                          time to time;
                        </li>
                        <li className="py-5">
                          <b>7. </b>o maintain records and provide you with an
                          efficient, safe and customized experience while using
                          the Platform;
                        </li>
                        <li className="py-5">
                          <b>8. </b>To analyze overall trends to helps us
                          improve the Platform and Services;
                        </li>
                        <li className="py-5">
                          <b>1. </b>Verify your identity and prevent fraud or
                          other unauthorized or illegal activity;
                        </li>
                        <li className="py-5">
                          <b>9. </b>To comply with applicable laws, rules, and
                          regulations;
                        </li>
                        <li className="py-5">
                          <b>10. </b>To transfer the data and the rights
                          associated therewith to any other body corporate in
                          case of merger or acquisition;
                        </li>
                        <li className="py-5">
                          <b>11. </b>And in any other way consistent with this
                          Privacy Policy.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="mb15 py-10 text-justify">
                    <strong>DISCLOSURES:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We do not sell, rent, share, distribute, lease, or otherwise
                    provide your Personal Information to third parties, without
                    your prior consent. However, we may share/disclose the
                    information in the following circumstances:
                  </p>
                  <div className="col-lg-12 ml10">
                    <div className="mt0">
                      <ul className="order_list list-style-type-bullet list-inline-item">
                        <li className="py-5">
                          <b>1. </b>To provide the services to the Users;
                        </li>
                        <li className="py-5">
                          <b>. </b>To the vendors engaged by the Company to
                          provide services to the Company;
                        </li>
                        <li className="py-5">
                          <b>3. </b>To carry out the obligations arising from
                          any contract between the Users and the Company;
                        </li>
                        <li className="py-5">
                          <b>4. </b>For any other purpose disclosed at the time
                          you provide the information;
                        </li>
                        <li className="py-5">
                          <b>5. </b>We may share your information with external
                          organizations or individuals if we believe that
                          access, use, preservation, or disclosure of the
                          information is reasonably necessary to: meet any
                          applicable law, regulation, legal process or
                          enforceable governmental request, detect, prevent, or
                          otherwise address fraud, security or technical issues
                          or protect against harm to the rights, property or
                          safety of our Users or the public as required or
                          permitted by law;
                        </li>
                        <li className="py-5">
                          <b>6. </b>If we are involved in a merger, acquisition
                          or asset sale, in which case Users’ personal data will
                          also be transferred;
                        </li>
                        <li className="py-5">
                          <b>7. </b>With our business partners who may contact
                          you by their own services or products that may
                          interest you, and
                        </li>
                        <li className="py-5">
                          <b>8. </b>To enforce or apply our Terms of Use and
                          other agreements, including for billing and collection
                          purposes.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="mb15 py-10 text-justify">
                    <b>9. </b>In case the Company is required to disclose the
                    Personal Information to government officials or such third
                    parties as required under the applicable laws, rules and
                    regulations or by law enforcement officers for any
                    investigations, verification, or for any legal purposes, we
                    will be entitled to disclose the same upon receiving a
                    written request in this regard.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <b>10. </b>In case the Company is acquired by or merged with
                    another company, we shall transfer the information disclosed
                    by the Users and information about the Users to the company
                    we are acquired by or merged with, and such company will
                    have the right to continue to use the Users’ Personal
                    Information.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>DATA TRANSFER:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    The Company processes the Personal Information only in India
                    and the Users’ consent to the transfer, storage, usage and
                    disclosure of information in accordance with this Privacy
                    Policy.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>DATA RETENTION AND DELETION:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We store the information collected as described in this
                    Privacy Policy for as long as you use our Services, or as
                    may be required to fulfil our legal obligations. If you stop
                    using the Platform, or your permission to use the Platform
                    is terminated, we may continue to use your data as per this
                    Privacy Policy, subject to your rights below. We may delete
                    your data upon reasonable written request for the same. In
                    any event, your data may be retained till such time as
                    required for the purpose of compliance with applicable laws.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>USERS’ RIGHTS:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    Users have a right to ensure that their Personal Information
                    is accurate, complete, and up to date. Accordingly, at any
                    point in time, the Users can change their Personal
                    Information by accessing the Edit Profile section on the
                    Platform. Users shall be responsible for maintaining the
                    confidentiality of their account and for all other
                    activities that occur under their account. The Company shall
                    not be liable for any loss that Users may incur as a result
                    of someone else using their password or account, either with
                    or without their knowledge. Users shall not use any other
                    User’s account at any time, without the express permission
                    of the concerned account holder.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    The Company will take reasonable steps to ensure that all
                    dealings in Personal Information, as defined hereunder,
                    shall:
                  </p>
                  <div className="col-lg-12 ml10">
                    <div className="mt0">
                      <ul className="order_list list-style-type-bullet list-inline-item">
                        <li className="py-5">
                          be processed fairly & lawfully;
                        </li>
                        <li className="py-5">
                          be obtained only with the consent of the Users;
                        </li>
                        <li className="py-5">be collected, only when:</li>
                        <ul className="list-style-type-bullet list-inline-item">
                          <li className="py-5">
                            the information is collected for a lawful purpose
                            connected with a function or activity of the
                            Company; and
                          </li>
                          <li className="py-5">
                            the collection of the sensitive personal data or
                            information is considered necessary for that
                            purpose.
                          </li>
                        </ul>
                        <li className="py-5">
                          be available for review by the Users, as and when
                          requested.
                        </li>
                        <li className="py-5">
                          be kept secure against unauthorized or unlawful
                          processing and against accidental loss, destruction,
                          or damage, as per the prescribed standards.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="mb15 py-10 text-justify">
                    <strong>CHANGES TO THIS POLICY:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We reserve the right to update, change or modify this
                    Privacy Policy at any time. The Privacy Policy shall come to
                    effect from the date of such update, change, or
                    modification.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>DISCLAIMER:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We shall not be responsible for any breach of security or
                    for any actions of any third parties or events that are
                    beyond the reasonable control of the Company including but
                    not limited to, acts of government, computer hacking,
                    unauthorized access to computer data and storage devices,
                    computer crashes, breach of security and encryption, poor
                    quality of Internet service or telephone service of the
                    Users, etc.
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>GRIEVANCE REDRESSAL:</strong>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We are committed to resolving any grievances that Users may
                    have regarding our privacy practices. Accordingly, in case
                    of any grievance, Users may contact our grievance officer
                    at:
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>Designation:</strong> Grievance Officer
                  </p>
                  <p className="mb15 py-10 text-justify">
                    <strong>Email:</strong>{" "}
                    <a href="mailto:fitizenindia@gmail.com">
                      fitizenindia@gmail.com
                    </a>
                  </p>
                  <p className="mb15 py-10 text-justify">
                    We shall make all efforts to address Users’ grievances at
                    the earliest possible opportunity. Users can always withdraw
                    their consent for usage, processing of their information by
                    us by writing to us. However, in such an event, we fully
                    reserve the right to withdraw further usage of the Platform
                    and provision of Services thereunder to the User.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermAndCondition;
